<template>
  <div class="fee-estimate" v-if="estimate">
    <div class="fee-card">
      <div class="fee-line" v-for="(item, idx) in estimate.items" :key="idx">
        <span class="fee-label">{{ item.size }}</span>
        <span class="fee-amount">${{ fmt(item.fee) }}</span>
      </div>

      <div class="fee-divider"></div>

      <div class="fee-line" v-if="estimate.subtotal != null">
        <span class="fee-label">Subtotal</span>
        <span class="fee-amount">${{ fmt(estimate.subtotal) }}</span>
      </div>
      <div class="fee-divider thick"></div>

      <div class="fee-line total">
        <span class="fee-label">Total</span>
        <span class="fee-amount">${{ fmt(estimate.total) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FeeEstimate',
  props: {
    estimate: { type: Object, default: null }
  },
  methods: {
    fmt (v) {
      if (v == null) return '—'
      return Number(v).toFixed(2)
    }
  }
}
</script>

<style scoped>
.fee-estimate { margin-bottom: 20px; }

.fee-card {
  background: #fff;
  border: 1px solid #e8ecf1;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 1px 3px rgba(0,0,0,.04);
}

.fee-line {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 0;
  font-size: 14px;
  color: #1a1a2e;
}

.fee-line.total {
  font-size: 16px;
  font-weight: 700;
}

.fee-line.total .fee-amount {
  color: #3b82f6;
  font-size: 18px;
}

.fee-divider {
  height: 1px;
  background: #e8ecf1;
  margin: 8px 0;
}

.fee-divider.thick {
  height: 2px;
  background: #1a1a2e;
}
</style>



// WEBPACK FOOTER //
// src/components/FeeEstimate.vue